<template>
 <canvas id="qr1" class="mx-auto">

</canvas>
</template>

<script>
import { reactive, toRefs } from 'vue'
//import {useStore} from "vuex";
//border-24 border-dashed
import QRious from "qrious";
import QRHelper from "./../../../../helpers/QRHelper.js";
export default {
    async setup () {
        
        const state = reactive({
            count: 0,
        })
    
        return {
            ...toRefs(state),
        }
    },
    mounted(){
        let toEmbed = QRHelper.createPatientQRData( this.$store.state.patientAddress, 
                                                    this.$store.state.patientFirstName, 
                                                    this.$store.state.patientMiddleInitial, 
                                                    this.$store.state.patientLastName, 
                                                    this.$store.state.patientBirthday,
                                                    this.$store.state.patientRace,
                                                    this.$store.state.patientGender,
                                                    this.$store.state.patientRedeemCode)
        new QRious({
            element: document.getElementById("qr1"),
            value: toEmbed,
            size: '180'
         });
    }
}
</script>

<style lang="scss" scoped>

</style>